import React from "react";
import SvgIcon from "./SvgIcon";
import { useDeviceInfo } from "@/hooks/useDeviceInfo";
import moonOn from "@/assets/img/icons/moonOn.svg";
import moonOff from "@/assets/img/icons/moonOff.svg";
import personOn from "@/assets/img/icons/personOn.svg";
import personOff from "@/assets/img/icons/personOff.svg";

export enum AstroPrognosisTab {
  Astro = "astro",
  Zodiac = "zodiac",
}

const TABS = [
  {
    key: AstroPrognosisTab.Astro,
    label: "Астрологический прогноз",
    iconPathActive: moonOn,
    iconPathInactive: moonOff,
  },
  {
    key: AstroPrognosisTab.Zodiac,
    label: "Зодиакальный прогноз",
    iconPathActive: personOn,
    iconPathInactive: personOff,
  },
];

interface BottomTabBarProps {
  activeTab: AstroPrognosisTab;
  onAstroPrognosisClick: () => void;
  onZodiacPrognosisClick: () => void;
}

// Компонент для отдельного таба
interface TabItemProps {
  children: React.ReactNode;
  isActive: boolean;
  onClick: () => void;
}

function TabItem({ children, isActive, onClick }: TabItemProps) {
  return (
    <button
      className={`flex-1 flex flex-col items-center justify-center py-2 transition ${
        isActive ? "text-cyan-400 font-bold" : "text-white/60"
      }`}
      onClick={onClick}
    >
      {children}
    </button>
  );
}

// Компонент для иконки таба
interface TabIconProps {
  iconPathActive: string;
  iconPathInactive: string;
  isActive: boolean;
}

function TabIcon({
  iconPathActive,
  iconPathInactive,
  isActive,
}: TabIconProps) {
  const iconPath = isActive ? iconPathActive : iconPathInactive;
  const iconSize = isActive ? "w-8 h-8" : "w-6 h-6";
  const minHeight = isActive ? "32px" : "24px";

  return (
    <div
      className={`${iconSize} flex items-center justify-center transition-all duration-200`}
      style={{ minHeight }}
    >
      <img src={iconPath} alt="" className="w-full h-full object-contain" />
    </div>
  );
}

// Компонентный контейнер для таб бара
interface TabBarContainerProps {
  children: React.ReactNode;
}

function TabBarContainer({ children }: TabBarContainerProps) {
  return (
    <div
      className="fixed bottom-0 left-0 w-full bg-[#152A3D] border-t border-white/10 flex justify-center items-center z-30 "
      style={{

        minHeight: "4rem",
      }}
    >
      <div className="flex w-full max-w-xl mx-auto">{children}</div>
    </div>
  );
}

// Основной компонент (обновленный подход)
function BottomTabBar({
  activeTab,
  onAstroPrognosisClick,
  onZodiacPrognosisClick,
}: BottomTabBarProps) {

  const [bottomPosition, setBottomPosition] = React.useState("");

  const deviceInfo = useDeviceInfo();
  React.useEffect(() => {
    if(!deviceInfo.isStandalone) {
      setBottomPosition("top-[calc(100svh-4rem)]");
    } else {
      setBottomPosition("bottom-0");
    }
  }, [deviceInfo]);
  
  return (
    <div
      className={`fixed ${bottomPosition} left-0 w-full bg-[#152A3D] border-t border-white/10 flex justify-center items-center z-30`}
      style={{
        minHeight: "4rem",
      }}
    >
      <div className="flex w-full max-w-xl mx-auto">
        {TABS.map((tab) => {
          const isActive = tab.key === activeTab;
          return (
            <button
              key={tab.key}
              className={`flex-1 flex flex-col items-center justify-center py-2 transition ${
                isActive ? "text-cyan-400" : "text-white/60"
              }`}
              onClick={() => {
                if (tab.key === AstroPrognosisTab.Astro) {
                  onAstroPrognosisClick();
                } else if (tab.key === AstroPrognosisTab.Zodiac) {
                  onZodiacPrognosisClick();
                } else {
                  console.error("Invalid tab key");
                }
              }}
            >
              <div
                className={`flex items-center justify-center transition-all  overflow-hidden bg w-6 h-6`}
                style={{ minHeight: isActive ? "24px" : "24px" }}
              >
                <SvgIcon src={tab.iconPathInactive} className={`w-6 h-6`} color={isActive ? "#18616F" : "#FFFFFF"} />
              </div>
              <span className="text-xs mt-1">{tab.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default BottomTabBar;
export { TabBarContainer, TabItem, TabIcon };
